import { render, staticRenderFns } from "./AppointmentConfirmation.vue?vue&type=template&id=c0ae6e7c&scoped=true&"
import script from "./AppointmentConfirmation.vue?vue&type=script&lang=js&"
export * from "./AppointmentConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentConfirmation.vue?vue&type=style&index=0&id=c0ae6e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ae6e7c",
  null
  
)

export default component.exports